import React from 'react';
import PropTypes from 'prop-types';
import { Link as InternalLink } from 'react-router-dom';
import styled from 'styled-components';
import { gridSizes, weights } from 'utils/style';
import { Field } from '@ontruck/orc';
import { Button } from 'refactored/ui/form';
import routes from 'utils/routes';
import { connect } from 'react-redux';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';

import { selectors, actions } from 'state/auth';

const LandingLoginFormComponent = ({
  className,
  username,
  password,
  setUsername,
  setPassword,
  handleSubmit,
  error,
  t,
}) => {
  return (
    <div className={className}>
      <h2 className="title">{t('title')}</h2>
      <form className={`form ${error && 'form-error'}`} onSubmit={handleSubmit}>
        <Field
          id="username"
          type="email"
          name="username"
          onChange={setUsername}
          label={t('username_label')}
          fullWidth
          value={username}
          dataE2E="login_username"
        />
        <div className="tax-data inspectlet-sensitive">
          <Field
            id="password"
            name="password"
            onChange={setPassword}
            label={t('password_label')}
            type="password"
            fullWidth
            value={password}
            dataE2E="login_password"
          />
        </div>
        {error && (
          <p data-e2e="login_error_message" className="error-msg">
            {t(error)}
          </p>
        )}
        <Button
          id="submit"
          type="submit"
          size="L"
          text={t('button_label')}
          dataE2E="login_submit"
        />
      </form>
      <InternalLink
        to={routes.loginRecover}
      >
        {t('password_recovery')}
      </InternalLink>
    </div>
  );
};

LandingLoginFormComponent.propTypes = {
  className: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setUsername: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  t: PropTypes.func,
  error: PropTypes.string.isRequired,
};

LandingLoginFormComponent.defaultProps = {
  t: (t) => t,
};

const StyledLandingLoginForm = styled(LandingLoginFormComponent)`
  padding: 16px 0 16px 0; 
  width: 100%;
  max-width: 350px;
  background: var(--white);
  color: var(--grey800);
  font-size: ${gridSizes('M')};
  border-bottom: 1px solid var(--grey300);

  .title {
    font-weight: ${weights('medium')};
    font-size: ${gridSizes('L')};
    margin: 0;
    color: var(--grey800);
  }
  .form {
    margin: 12px 0 0;
    div input {
      border: 1px solid var(--grey200);
      border-radius: 4px;
      margin:4px 0;
      color: var(--grey800);
    }
  }
  .form-error {
    div input {
      border: 1px solid var(--red-cherry-text);
    }
  }
  .error-msg {
    font-size: 14px;
    color: var(--red-cherry-text);
    margin: ${gridSizes('S')} 0 0;
  }
  button {
    margin: ${gridSizes('S')} 0 0;
    width: 100%;
    height: 32px !important;
    font-size: 14px !important;
  }
  a {
    display: block;
    font-size: 14px;
    font-weight: ${weights('medium')};
    color: var(--grey700);
    text-decoration: none;
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const enhance = compose(
  withTranslation('authLoginForm'),
  connect(
    (state) => ({
      error: selectors.getAuthError(state),
    }),
    {
      login: actions.login,
    }
  ),
  withStateHandlers(
    ({ username = '', password = '' }) => ({
      username,
      password,
    }),
    {
      setUsername:
        () =>
        (e, { value }) => ({
          username: value,
        }),
      setPassword:
        () =>
        (e, { value }) => ({
          password: value,
        }),
    }
  ),
  withHandlers({
    handleSubmit:
      ({ login, username, password }) =>
      (e) => {
        e.preventDefault();
        login({ username, password });
      },
  })
);

const LandingLoginForm = enhance(StyledLandingLoginForm);
export { LandingLoginForm };